import React, { Fragment } from 'react';
import { css } from 'aphrodite/no-important';

import styles from './gatewayRow.styles';
import HealthIndicators from '../common/healthIndicators';
import NoDataFound from '../common/noDataFound';

export const GatewayRow = props => {
  const { status } = props;
  if (status) {
    let deleteDiv =(<div
      className={css(styles.field, styles.notrash)}
    >
    </div>)
    if(!status.siteId){
      deleteDiv = (<div
      className={css(styles.field, styles.trash)}
      onClick={() => props.handleDeleteModalState(status)}
    >
      <span className="lnr lnr-trash " />
    </div>);
    }
    return (
      <Fragment>
        <div className={css(styles.base)}>
          <div className={css(styles.field, styles.status)}>
            <HealthIndicators status={status} />
          </div>
          <div
            className={css(styles.field, styles.nodeAddress)}
            title={status && status.nodeAddress}
          >
            <span className={css(styles.name)}>
              {status && status.nodeAddress}
            </span>
          </div>
          <div
            className={css(styles.field, styles.nodeAddress)}
            title={status && status.nodeName}
          >
            <span className={css(styles.name)}>
              {status && status.nodeName}
            </span>
          </div>
          <div className={css(styles.field, styles.downtime)}>
            {status && status.downtime}
          </div>
          {deleteDiv}
        </div>
      </Fragment>
    );
  }
  return <NoDataFound styles={styles.gatewayNoDataRow} />;
};

export default GatewayRow;



// WEBPACK FOOTER //
// ./src/components/data/status/gateway/gatewayRow.js